import TextField from '@mui/material/TextField';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import { forwardRef, useId } from 'react';
import { NumericFormat } from 'react-number-format';

const CurrencyInput = forwardRef(function _CurrencyInput({
  error,
  helper,
  label,
  readOnly,
  value,
  onChange,
  onBlur,
  name,
  startAdornment,
  endAdornment,
  decimalScale = 2,
  fixedDecimalScale = false,
  prefix = 'HKD ',
  allowNegative = false,
  placeholder = 'HKD 0.00',
  ...props
}, ref) {
  const inputId = useId();

  const min = 0; // Minimum allowed value
  const max = 99999999.99; // Maximum allowed value

  return (
    <NumericFormat
      getInputRef={ref}
      customInput={TextField}
      variant='filled'
      id={inputId}
      name={name}
      label={label}
      value={value || ''}
      isAllowed={(values) => {
        const { floatValue } = values;
        if (floatValue !== undefined && (floatValue < min || floatValue > max)) {
          return false;
        }

        return true;
      }}

      onValueChange={(values) => {
        if (onChange) {
          onChange({
            target: {
              name,
              value: values.floatValue,
            },
          });
        }
      }}
      onBlur={onBlur}
      error={error}
      helperText={helper}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      prefix={prefix}
      allowNegative={allowNegative}
      placeholder={placeholder}
      slotProps={{
        input: {
          readOnly,
          startAdornment,
          endAdornment,
        },
      }}
      {...omit(props, ['ref', 'getValue', 'isReadOnly', 'registerOptions'])}
    />
  );
});

CurrencyInput.propTypes = {
  helper: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
  thousandSeparator: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  allowNegative: PropTypes.bool,
};

export default CurrencyInput;
